const TOLERANCE_EXCELLENT = 1;
const TOLERANCE_SIMILAR = 3;

/** Compares a product's measurements against a customer's saved reference measurement.
 * Returns null when there isn't enough verified data to make a confident claim. */
export function getFitLabel(product, reference) {
  if (!reference || !product?.lens_width || !product?.bridge_width || !product?.temple_length) return null;
  const lensDiff = product.lens_width - reference.lens_width;
  const bridgeDiff = product.bridge_width - reference.bridge_width;
  const templeDiff = product.temple_length - reference.temple_length;
  const maxAbsDiff = Math.max(Math.abs(lensDiff), Math.abs(bridgeDiff), Math.abs(templeDiff));

  if (maxAbsDiff <= TOLERANCE_EXCELLENT) return "Excellent Match";
  if (maxAbsDiff <= TOLERANCE_SIMILAR) return "Similar Fit";
  if (lensDiff > TOLERANCE_SIMILAR || templeDiff > TOLERANCE_SIMILAR) return "Wider Than Your Size";
  if (lensDiff < -TOLERANCE_SIMILAR || templeDiff < -TOLERANCE_SIMILAR) return "Narrower Than Your Size";
  return null;
}
